// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2kKu-","location":"Header_location__2iG5d"};